export default __webpack_public_path__ + "static/media/RobotoCondensed-BoldItalic.0da253db.ttf";